import {
  initSelectedTimeSlots,
  initValiableTimeSlots,
  prepareTimeSlotsToSubmit,
} from 'feature/appeals/helpers'
import { stateCurrentAppeal } from 'feature/appeals/redux/appealFormCreateSelector'
import {
  useEditAppealMutation,
  useGetTimeSlotsQuery,
} from 'feature/appeals/redux/appeals.api'
import { TTimeSlot } from 'feature/appeals/type'
import { ProductOrderHeader } from 'feature/productOrder/CreateOrder/ProductOrderHeader'
import { useSetNotice } from 'hooks/useSetNotice'
import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useAppSelector, useActions } from 'store/hooks'
import { LoaderInCentalPosition } from 'widget'
import { ModalCloseButton } from 'widget/ModalCloseButton/ModalCloseButton'
import { Severity } from 'widget/Notifications'

import { EditTimeSlotsForm } from '../EditTimeSlotsForm/EditTimeSlotsForm'

import style from './ModalTimeSlotsEdit.module.scss'

type TModalTimeSlotsEdit = {
  userSelectedTimeSlots: TTimeSlot[]
  timeSlotTitle: string
  onClose: () => void
}

// модальное окно для формы переноса замера

export function ModalTimeSlotsEdit({
  timeSlotTitle,
  userSelectedTimeSlots,
  onClose,
}: TModalTimeSlotsEdit) {
  const [isButtonDisabled, setButtonDisabled] = useState<boolean>(false)
  const [isButtonLoading, setButtonLoading] = useState<boolean>()
  const newAppealData = useAppSelector(state => state.newAppeal)
  //выбранные пользователем новые таймслоты
  const { userSelectedSlots, availableSlotsList } =
    useAppSelector(stateCurrentAppeal)

  const [editAppeal] = useEditAppealMutation()
  const { setAvaliableSlotList, setSelectedTimeSlot } = useActions()

  const { data, isLoading } = useGetTimeSlotsQuery(
    newAppealData?.location?.regionFiasId || '',
  )

  const setNotice = useSetNotice()

  const methods = useForm()
  const {
    formState: { errors },
  } = methods

  const onSubmit = () => {
    const timeSlots = prepareTimeSlotsToSubmit(userSelectedSlots)
    setButtonLoading(true)

    const newUserAppeal = {
      uid: newAppealData.uid,
      orderId: newAppealData.orderId,
      timeSlots: timeSlots,
    }

    editAppeal(newUserAppeal)
      .unwrap()
      .then(res => {
        if ('error' in res) {
          //@ts-ignore
          const error = res.error.data
          setNotice(error.message, Severity.error)
          setButtonLoading(false)
          return
        }
        onClose()
        setNotice(res.message, Severity.success)
        setButtonLoading(false)
      })
      .catch(error => {
        setButtonLoading(false)

        if (error.data.message) {
          setNotice(error.data.message, Severity.error)
          return
        }
        setNotice('Ошибка отправки адреса', Severity.error)
      })
  }

  useEffect(() => {
    if (data?.list && newAppealData?.timeSlots) {
      setAvaliableSlotList(
        initValiableTimeSlots(data?.list, userSelectedTimeSlots),
      )
      setSelectedTimeSlot(initSelectedTimeSlots(userSelectedTimeSlots))
    }
  }, [data, newAppealData, setAvaliableSlotList, setSelectedTimeSlot])

  return (
    <div className={style.modalTimeSlotsEdit}>
      <div className={style.headerWrapper}>
        <ProductOrderHeader
          title={timeSlotTitle}
          description='Выберите удобные даты и время, чтобы
            провести замер под изделие на вашем объекте'
        />
        <ModalCloseButton onClose={onClose} />
      </div>
      {data && !isLoading && (
        <FormProvider {...methods}>
          <EditTimeSlotsForm
            onSubmit={onSubmit}
            userSelectedSlots={userSelectedSlots}
            availableSlotsList={availableSlotsList}
            isButtonDisabled={Boolean(
              isButtonDisabled ||
                !!Object.entries(errors).length ||
                isButtonLoading,
            )}
            isButtonLoading={Boolean(isButtonLoading)}
            setButtonDisabled={setButtonDisabled}
            onClose={onClose}
          />
        </FormProvider>
      )}

      {isLoading && <LoaderInCentalPosition />}
      {!isLoading && !data && (
        <div className={style.error}>Ошибка. Попробуйте еще раз</div>
      )}
    </div>
  )
}
